import React, { Component } from "react";
import { connect } from "react-redux";
import { classCodeRemove } from "../../actions/classCodesActions";

class Remove extends Component {
  removeClassCode = cCode => {
    const res = window.confirm(
      `${cCode} 클래스 코드를 삭제하시겠어요? (나중에 다시 생성할 수 있습니다.)`
    );

    if (res) {
      console.log("click: ", res);
      this.props.classCodeRemove(cCode);
    }
  };

  render() {
    const { cCode } = this.props.location.params || {};

    return cCode ? (
      <div style={{ marginLeft: 10 }}>
        <button
          type="button"
          className={`btn btn-sm btn-outline-danger`}
          onClick={() => {
            this.removeClassCode(cCode);
          }}
        >
          -
        </button>
      </div>
    ) : (
      false
    );
  }
}

const mapStateToProps = ({ location }) => ({ location });
export default connect(
  mapStateToProps,
  { classCodeRemove }
)(Remove);
